import React, { useContext, useState } from 'react';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';
import { CHAT_FILTERS_SLUGS } from '../../../constants';

const ChatArchivedFilter = ({ defaultValue, handleClose, onApply, onChange, search, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const [values, setValues] = useState(defaultValue || []);

  const filterLabel = t(CHAT_FILTERS_SLUGS.archived);

  const OPTIONS = [
    { value: 'archived', label: t('chatArchivedFilter') },
    { value: 'unarchived', label: t('chatUnarchivedFilter') }
  ];

  const searchLower = search?.toLowerCase();
  const filteredOptions = searchLower
    ? OPTIONS.filter(({ label }) => label.toLowerCase().includes(searchLower))
    : OPTIONS;

  if (search && !filterLabel.toLowerCase().includes(searchLower) && !filteredOptions.length) {
    return null;
  }

  const visibleOptions = filterLabel.toLowerCase().includes(searchLower) ? OPTIONS : filteredOptions;

  const handleChange = (option) => {
    const newValues = values.includes(option) ? values.filter((item) => item !== option) : [...values, option];
    setValues(newValues);
    onChange?.(newValues);
  };

  return (
    <FilterLayout name={filterLabel} handleClose={handleClose} onApply={() => onApply(values)} hideLayout={hideLayout}>
      {visibleOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`chat-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default ChatArchivedFilter;
